var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0909 2H3.72727C2.22364 2 1 3.22364 1 4.72727V20C1 21.1046 1.89543 22 3 22H20.8182C21.9228 22 22.8182 21.1046 22.8182 20V4.72727C22.8182 3.22364 21.5945 2 20.0909 2ZM21 19.1818C21 19.7341 20.5523 20.1818 20 20.1818H3.81818C3.2659 20.1818 2.81818 19.7341 2.81818 19.1818V4.72727C2.81818 4.22636 3.22636 3.81818 3.72727 3.81818H20.0909C20.5918 3.81818 21 4.22636 21 4.72727V19.1818ZM5.5 6.54545H18.2727V8.36364H5.5V6.54545ZM5.5 11.0909H18.2727V12.9091H5.5V11.0909ZM5.5 15.6364H18.2727V17.4545H5.5V15.6364Z",
    fill: "#5D616D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayWall);
export default __webpack_public_path__ + "static/media/Display Wall.45d2c34849c68cdc8ff9fc183ad4831a.svg";
export { ForwardRef as ReactComponent };